import { newDataLisFunc } from './dataList';
const contractModules = {
    tianfuBankContract: () => import(`../views/contractModules/tianfuBankContract/Index`),
    contractManage: () => import(`../views/contractModules/contractManage/Index`),
    accountManage: () => import(`../views/customerModules/accountManage/Index`),
    contractGroupManage: () => import(`../views/contractModules/contractGroupManage/Index`),
    contractView: () => import(`../views/contractModules/contractView/Index`),
    contractArchive: () => import(`../views/contractModules/contractArchive/Index`),
    contractRegistration: () => import(`../views/contractModules/contractRegistration/Index`),
    companyManagerArchive: () => import(`../views/basicSettings/companyManagerArchive/Index`),
    industryList: () => import(`../views/basicSettings/industryList/Index`),
    opportunity: () => import(`../views/opportunityModules/opportunity/Index`),
    flowAbandom: () => import(`../views/basicSettings/flowAbandom/Index`),
    failList: () => import(`../views/basicSettings/failList/Index`),
    organization: () => import(`../views/basicSettings/organization/Index`),
    organizationLog: () => import(`../views/basicSettings/organizationLog/Index`),
    ...newDataLisFunc(`contract`, 10)
};
const customerModules = {
    customer: () => import(`../views/customerModules/customer/Index`),
    customerSeries: () => import(`../views/customerModules/customerSeries/Index`),
    customerAuth: () => import(`../views/customerModules/customerAuth/Index`),
    customerPersonResponsible: () => import(`../views/customerModules/customerPersonResponsible/Index`),
    customerPersonResponsibleData: () => import(`../views/customerModules/customerPersonResponsibleData/Index`),
    customerPersonResponsibleImport: () => import(`../views/customerModules/customerPersonResponsibleImport/Index`),
    revenueForecast: () => import(`../views/customerModules/revenueForecast/Index`),
    revenueVersion: () => import(`../views/customerModules/revenueVersion/Index`),
    revenueFactor: () => import(`../views/customerModules/revenueFactor/Index`),
    customerGroup: () => import(`../views/customerModules/customerGroup/Index`),
    customerManage: () => import(`../views/customerModules/customerManage/Index`),
    customerIntroduction: () => import(`../views/customerModules/customerIntroduction/Index.vue`),
    customerVisitManage: () => import(`../views/customerModules/customerVisitManage/Index.vue`),
    biddingAccountManage: () => import(`../views/customerModules/biddingAccountManage/Index.vue`),
    tycMapReport: () => import(`../views/customerModules/tycMapReport/Index.vue`),
    assetHandover: () => import(`../views/customerModules/assetHandover/index.vue`),
    ...newDataLisFunc(`customer`, 10)
};
const customerManagerModules = {
    repaymentPlan: () => import(`../views/customerManagerModules/repaymentPlan/Index`),
    ...newDataLisFunc(`customerManager`, 10)
};
const dataModules = {
    ...newDataLisFunc(`data`, 10)
};

const pendingManagerModules = {
    renewalPending: () => import(`../views/pendingManagerModules/renewalPending/Index.vue`),
    renewalEdit: () => import(`../views/pendingManagerModules/renewalEdit/Index.vue`),
    revenuePending: () => import(`../views/pendingManagerModules/revenuePending/Index.vue`),
    ...newDataLisFunc(`pendingManager`, 10)
};

const targetModules = {
    submissionApplication: () => import(`../views/targetModules/submissionApplication/index`),
    monthProgressReport: () => import(`../views/targetModules/monthProgressReport/index`),
    monthRulesConfigurationSheet: () => import(`../views/targetModules/monthRulesConfigurationSheet/index`),
    mainReport: () => import(`../views/targetModules/mainReport/Index`),
    groupKpiReport: () => import(`../views/targetModules/groupKpiReport/Index`),
    kpiReport: () => import(`../views/targetModules/kpiReport/Index`),
    typeReport: () => import(`../views/targetModules/typeReport/Index`)
};
const leadManagementModules = {
    leadImportManage: () => import(`../views/leadManagerModules/leadImportManage/Index`),
    ...newDataLisFunc(`leadManager`, 10)
};
export default {
    ...contractModules,
    ...customerModules,
    ...dataModules,
    ...customerManagerModules,
    ...pendingManagerModules,
    ...targetModules,
    ...leadManagementModules
};
